<template>
  <div v-if="categoryIsLoad" class="comp-main" :style="{ width }">
    <div
      :class="{ 'comp-top': true, disabled: !!categoryTextureStr }"
      :title="promptStr"
      @click="toggleCategory"
    >
      <div class="comp-title">
        <span>{{ categoryActiveStr }}</span>
        <el-link v-if="!categoryTextureStr" class="m-l-10" type="primary">
          {{ toggleStr }}
        </el-link>
      </div>
    </div>
    <div v-if="!categoryTextureStr" v-show="isShowCategory" class="comp-cont">
      <b-goods-category
        :ids="categoryRouteIds"
        :isInit="isInit && !categoryRouteIds.length"
        :bao_han="bao_han"
        @success="getCategoryActiveList"
      />
      <div v-if="isLoadTexture" style="margin-left: -1px">
        <Texture :categoryId="categoryLastId" :data.sync="textureActiveObj" @hide="hideCategory" />
      </div>
    </div>
  </div>
</template>

<script>
import Texture from './texture'
export default {
  components: {
    Texture
  },
  props: {
    isInit: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      required: true
    },
    bao_han: {
      type: Array,
      default: () => {
        return []
      }
    },
    categoryTextureStr: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'auto'
    },
    isLoadTexture: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShowCategory: false,
      categoryIsLoad: false,
      categoryLastId: '',
      categoryRouteIds: [],
      categoryActiveList: [],
      textureActiveObj: {}
    }
  },
  computed: {
    // 类目末级选中对象
    categoryLastActiveObj() {
      let result = ''
      let len = this.categoryActiveList.length
      if (len) result = this.categoryActiveList[len - 1]
      return result
    },
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      if (this.categoryTextureStr) {
        result = this.categoryTextureStr
      } else {
        let listName = this.categoryActiveList.map((item) => item.name) // 类目
        if (this.textureActiveObj.key) listName.push(this.textureActiveObj.key) // 材质
        result = listName.join('/')
      }
      return result // 类目材质拼接成字符串
    },
    // 切换字符串
    toggleStr() {
      let result = this.isShowCategory ? '收起↑' : '展开↓'
      return result
    },
    // 提示字符串
    promptStr() {
      let result = `${this.categoryActiveStr}（点击${this.toggleStr}）`
      return result
    },
    // 类目材质选中数据
    categoryTextureActiveData() {
      let result = {
        category_list: this.$util.deepCopy(this.categoryActiveList),
        texture_data: this.$util.deepCopy(this.textureActiveObj)
      }
      return result
    }
  },
  watch: {
    categoryLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.categoryLastId = ''
        } else {
          this.categoryLastId = newVal.id
        }
      }
    },
    categoryTextureActiveData: {
      handler(val) {
        this.$emit('update:data', this.$util.deepCopy(val))
      },
      deep: true
    }
  },
  mounted() {
    this.initCategoryTextureData()
  },
  methods: {
    // 切换类目
    toggleCategory() {
      if (this.categoryTextureStr) return
      this.isShowCategory = !this.isShowCategory
    },
    // 隐藏类目
    hideCategory() {
      this.isShowCategory = false
    },
    // 初始化分类材质数据
    initCategoryTextureData() {
      this.categoryIsLoad = false
      let idsStr = this.$route.query.ids
      let idsList = []
      if (idsStr) idsList = idsStr.split(',')
      if (idsList.length) {
        this.categoryRouteIds = idsList.map((item) => Number(item))
      }
      if (this.data.category_list && this.data.category_list.length) {
        this.categoryRouteIds = this.data.category_list.map((item) => Number(item.id))
      }
      if (this.data.texture_data) {
        this.textureActiveObj = this.data.texture_data
      }
      this.categoryIsLoad = true
    },
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
            if (!itemNd.has_children && !this.isLoadTexture) this.hideCategory()
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  position: relative;
  .comp-top {
    padding: 0 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    &.disabled {
      color: @colorGrayC;
      background: @colorGrayF;
      cursor: not-allowed;
      font-size: 12px;
    }
    .comp-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 26px;
    }
  }
  .comp-cont {
    position: absolute;
    top: 33px;
    left: 0;
    display: flex;
  }
}
</style>
